<template lang="html">
  <div>
    <footer class="footer">
      <div class="content has-text-centered">
        <div class="columns">
          <div class="column">
            <h6>{{ $t("Footer.ABOUT") }}</h6>
            <p class="has-text-center">
              {{ $t("Footer.ABOUT_TEXT") }}
            </p>
          </div>
          <div v-if="!isCurrentUserStudent" class="column">
            <h6>{{ $t("Footer.CATEGORIES") }}</h6>
            <p>
              <router-link to="/create">{{ $t("Footer.CREATE") }}</router-link>
            </p>
            <p>
              <router-link to="/search">{{ $t("Footer.SEARCH") }}</router-link>
            </p>
            <p>
              <a href="/tutorials" target="_blank" rel="noopener">
                {{ $t("Header.TUTORIALS") }}
              </a>
            </p>
            <p>
              <a href="/goodPractices">
                {{ $t("Header.GOODPRACTICES") }}
              </a>
            </p>
            <p>
              <a href="/documentation" target="_blank" rel="noopener">
                {{ $t("Header.DOCUMENTATION") }}
              </a>
            </p>
          </div>
          <div v-if="!isCurrentUserStudent" class="column">
            <h6>{{ $t("Footer.LINKS") }}</h6>
            <p>
              <router-link to="/myprofile">{{
                $t("Footer.PROFILE")
              }}</router-link>
            </p>
            <p>
              <router-link to="/myactivities">{{
                $t("Footer.ACTIVITIES")
              }}</router-link>
            </p>
            <p>
              <router-link to="/mysequences">{{
                $t("Footer.SEQUENCES")
              }}</router-link>
            </p>
            <p>
              <router-link to="/news">{{ $t("Footer.NEWS") }}</router-link>
            </p>
            <!--   <p>
              <router-link to="/sponsor">{{
                $t("Footer.SPONSORS")
              }}</router-link>
            </p>-->
            <p>
              <router-link
                v-if="checkPermission('menu_price') || !currentUser"
                to="/pricing"
                >{{ $t("Footer.PRICE") }}</router-link
              >
            </p>
            <p @click="$router.push({
                  name: 'Logout',
                })">
              <router-link to="">{{ $t("Footer.SIGN_OUT") }}</router-link>
            </p>
          </div>
          <div v-if="!isCurrentUserStudent" class="column">
            <h6>{{ $t("Footer.SUPPORT") }}</h6>
            <p>
              <a :href="getURLForumFeatureRequests" target="_blank">{{ $t("Footer.FEATURE") }}</a>
            </p>
            <p>
              <a :href="getURLForumBugReports" target="_blank">
                {{ $t("Footer.BUG") }}
              </a>
            </p>
            <p v-if="!isCurrentUserStudent" target="_blank" rel="noopener" >
              <a :href="getURLEmailSupport">
                {{ $t("Footer.CONTACT") }}
              </a>
            </p>
           
          </div>
          <div class="column">
            <h6>{{ $t("Footer.INFORMATION") }}</h6>
            <p>
              <router-link to="/legalNotices">{{
                $t("Footer.LEGAL_NOTICES")
              }}</router-link>
            </p>
            <p v-if="checkPermission('external_links') || !currentUser">
              <router-link to="/opensource">{{
                $t("Footer.OPENSOURCE")
              }}</router-link>
            </p>  <p>
              <router-link to="/generalConditions">{{
                $t("Footer.GENERAL_CONDITIONS")
              }}</router-link>
            </p>
            <p>
              <router-link to="/dataProtection">{{
                $t("Footer.DATA_PROTECTION")
              }}</router-link>
            </p>
          </div>
        </div>
        <p v-if="checkPermission('external_links') || !currentUser">
          <a :href="getURLCompany">KDetude</a> {{ currentYear }} - Eleda
          {{ "v." + eledaVersion }} ({{ $formatMoment(new Date(eledaVersionDate), "ll") }})
        </p>
          <p v-else>KDetude {{ currentYear }} - Eleda
          {{ "v." + eledaVersion }} ({{ $formatMoment(new Date(eledaVersionDate), "ll") }})
        </p>
      </div>
    </footer>

    <b-modal
      v-model="isContactModalActive"
      scroll="keep"
      :can-cancel="['escape', 'outside']"
    >
      <div class="modal-card-body">
        <h1 class="has-text-centered is-size-2">
          Vous pouvez nous contacter par mail à l'adresse suivante :
          <b>contact@eleda.fr</b>
        </h1>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { siteName } from "../config/settings-network.mjs";
import UtilsMixin from "../mixins/UtilsMixin.js";

export default {
  name: "Footer",
  mixins: [UtilsMixin],

  props: {
    title: {
      type: String,
      default: "Footer",
    },
  },
  data() {
    return {
      test: siteName,

      isContactModalActive: false,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {},
};
</script>
